<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{(add) ? 'ADD PROMOTION CODE' : 'UPDATE PROMOTION CODE'}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new p-6" :settings="settings" :key="$vs.rtl">

      <vs-input label="Name" v-model="name" class="mt-2 w-full" name="item-name" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

      <vs-input label="Code" v-model="code" class="mt-2 w-full" name="item-code" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('item-code')">{{ errors.first('item-code') }}</span>


      <vs-input label="Minimun amount of payment" v-model="minValue" class="mt-2 w-full" name="item-min-value" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('item-min-value')">{{ errors.first('item-min-value') }}</span>

      <div class="mt-2">
        <label class="vs-input--label">Start Date</label>
        <div class="vx-row m-0">
          <div class="vx-col w-2/3 p-0">
            <div class="">
              <vs-input type="date" v-model="startDate" class="form-control pickatime picker__input picker__input--active" :name="'item-start-date'" v-validate="'required'" />
            </div>
          </div>
          <div class="vx-col w-1/3 p-0">
            <div class="">
              <vs-input type="time" v-model="startHour" class="form-control pickatime picker__input picker__input--active ml-2" :name="'item-start-hour'" v-validate="'required'" />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <label class="vs-input--label">End Date</label>
        <div class="vx-row m-0">
          <div class="vx-col w-2/3 p-0">
            <div class="">
              <vs-input type="date" v-model="endDate" class="form-control pickatime picker__input picker__input--active" :name="'item-end-date'" v-validate="'required'" />
            </div>
          </div>
          <div class="vx-col w-1/3 p-0">
            <div class="">
              <vs-input type="time" v-model="endHour" class="form-control pickatime picker__input picker__input--active ml-2" :name="'item-end-hour'" v-validate="'required'" />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <label class="mb-2">Type</label>
        <div>
          <vs-radio v-model="type" vs-value="percent" class="mr-4" vs-name="type-percent">Percent (%)</vs-radio>
          <vs-radio v-model="type" vs-value="static" class="mr-4" vs-name="type-static">Flat</vs-radio>
        </div>
      </div>

      <vs-divider />

      <vs-input label="Value" v-model="value" class="mt-5 w-full" name="item-value" v-validate="'required'" />
      <span class="text-danger text-sm" v-show="errors.has('item-value')">{{ errors.first('item-value') }}</span>


    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {
      id: null,
      add: true,
      name: '',
      code: '',
      minValue: 0,
      startDate: moment().format('yyyy-MM-DD'),
      startHour: moment().format('HH:mm'),
      endDate: moment().format('yyyy-MM-DD'),
      endHour: moment().format('HH:mm'),
      type: 'percent', //percent | static
      value: 0,
      restaurantId: 0,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (this.data.add) {
        const { add, restaurantId} = JSON.parse(JSON.stringify(this.data))
        this.initValues()
        this.add = add
        this.restaurantId = restaurantId

        this.$validator.reset()
      } else {
        const { id, add, restaurantId, name, code, min_value, start_date, end_date, type, value } = JSON.parse(JSON.stringify(this.data))
        this.initValues()
        this.id = id
        this.add = add
        this.restaurantId = restaurantId
        this.name = name
        this.code = code
        this.minValue = min_value
        this.startDate = this.formatDate(start_date)
        this.endDate = this.formatDate(end_date)
        this.type = type
        this.value = value

      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.code && this.minValue && this.startDate && this.endDate && this.type && this.value
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {

    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.code = ''
      this.minValue = 0
      this.startDate = moment().format('yyyy-MM-DD')
      this.startHour = moment().format('HH:mm')
      this.endDate = moment().format('yyyy-MM-DD')
      this.endHour = moment().format('HH:mm')
      this.type = 'percent'
      this.value = 0
      this.restaurantId = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            name: this.name,
            code: this.code,
            minValue: this.minValue,
            startDate: `${this.startDate} ${this.startHour}`,
            endDate: `${this.endDate} ${this.endHour}`,
            type: this.type,
            value: this.value,
            restaurantId: this.restaurantId
          }

          this.$store.dispatch('api/setCoupon', obj)
            .then(() => {
              this.$emit('closeSidebar')
              this.initValues()
            })
            .catch(err => {
              console.error(err)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .zip-font-2 {
    font-size:18px;
  }
  .zip-font {
    font-size: 22px;
  }
  .vs-con-input-label {
    width: unset;
  }
</style>
